import {
  resolveFeedActor,
  twinWorkFor,
  type ActorDisplay,
} from "@/components/app/feed/feed-actor";
import type {
  CurrentMlxUser,
  WorkspaceOrganizationMember,
} from "@/lib/mlx-workspace-client";

export type FeedActor = {
  label: string;
  imageUrl: string | null;
  initials: string;
  icon?: ActorDisplay["icon"];
  identity?: ActorDisplay["identity"];
};

/** A row's actor as shown: Twin, for the person, when a Twin run did the work. */
export function channelRowActor(
  actor: FeedActor,
  twinDidIt: boolean,
): { actor: FeedActor; onBehalfOf: string | null } {
  const twin = twinDidIt
    ? twinWorkFor({ name: actor.label, initials: actor.initials, imageUrl: actor.imageUrl, identity: actor.identity })
    : null;
  if (!twin) return { actor, onBehalfOf: null };
  return {
    actor: {
      label: twin.actor.name,
      initials: twin.actor.initials,
      imageUrl: null,
      icon: twin.actor.icon,
      identity: twin.actor.identity,
    },
    onBehalfOf: twin.onBehalfOf,
  };
}

export function feedActor(
  authorId: string | null,
  authorType: "user" | "agent" | "service" | "unknown",
  currentUser: CurrentMlxUser | null,
  membersByUserId: Map<string, WorkspaceOrganizationMember>,
): FeedActor {
  const actor = resolveFeedActor(
    {
      id: authorId ?? "",
      subjectId: null,
      type: authorType,
      clientApp: null,
      interfaceType: null,
      executedByTwin: false,
    },
    membersByUserId,
    new Set(currentUser ? [currentUser.id] : []),
    currentUser,
  );
  return {
    label: actor.name,
    imageUrl: actor.imageUrl,
    initials: actor.initials,
    ...(actor.icon ? { icon: actor.icon } : {}),
    identity: actor.identity,
  };
}
